/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react'
import {
  getProfile,
} from '../../../redux/Actions/getMethods'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { ActionTypes } from '../../../redux/Constants/actionTypes'
import AboutYouDetail from '../loanapplication/AboutYouDetail'
import AboutYouNoPhoneVerification from '../loanapplication/AboutYouNoPhoneVerification'
/* import AnalyticsContext from '../../../App' */
import { useLDClient } from 'launchdarkly-react-client-sdk'

function AboutYou() {
  const ldClient = useLDClient()

  // ==================== Checking user status  =======================//
  const token = localStorage.getItem('login')
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const temp = async () => {
      dispatch({ type: ActionTypes.LOADING_SUCCESS_WHOLE_SCREEN })
      const myID = await dispatch(getProfile())
      if (myID?.data?.id) {
        dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
        navigate('/address-detail')
      }
      dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
    }
    if (token) {
      temp()
    }
  }, [])

  console.log("ld user id: ", ldClient?.getContext()?.key)

  return (
    <>
      {ldClient?.variation('2025-07-web-home-test-1', false) ? (
        <AboutYouNoPhoneVerification />
      ) : (
        <AboutYouDetail />
      )}
    </>
  )
}

export default AboutYou
